import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { goals, LoginModel, UserPermissionsModel } from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { CustomToastsService } from '../../../../Services/custom-toasts.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.css']
})
export class GoalsComponent {
  // Core data
  goals: Array<goals> = [];
  goal: goals = new goals();
  goalValue: Array<goals> = [];
  goalIntervals: Array<goals> = [];
  goalGroups: Array<goals> = [];
  goalTypes: Array<goals> = [];
  exportList: any = [];
  userData: LoginModel = new LoginModel();
  
  // UI state
  headerCheckboxSelected: boolean = false;
  selectedgoalIds: string[] = [];
  selectedRowIndex: number | null = null;
  goalName: string = '';
  isEditable: boolean = true;
  isButtonActive: boolean = true;
  isUpdated = false;
  
  // Delete modal state
  deleteParameter: any = null;
  deleteButtonClickedWithoutSelection: boolean = false;
  deleteButtonClickedWithSelection: boolean = false;
  
  // Filter state
  GoalsArray: Array<goals> = [];
  GoalsArray1: Array<goals> = [];
  GoalsArrayforFilter: Array<goals> = [];
  ArrayForGoals: Array<goals> = [];
  filteredGoalGroup: Array<goals> = [];
  noData: boolean = false;
  filterName: string = 'goalType';
  filtergoalIds: number[] = [];
  isFilterModalOpen: boolean = false;
  isLoading: boolean = false;

  @ViewChild('modalConfirmCloseButton') modalConfirmCloseButton?: ElementRef<HTMLElement>;
  constructor(private permissionService: NgxPermissionsService, private userservice: UserserviceService, private masterservice: MasterDataSeriveService, private toastr: CustomToastsService, private adminBreadcrumbs: AdminBreadcrumbsService,
    private exportExcelService: ExportExcelService) { }

  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Company Config', link: 'demo' },
      { crumbName: 'Goals', link: '/admin/home/goals' },
    ]);

    this.userData = this.masterservice.getUserDetailsFromStorage();
    this.getgoals();
    this.getValue();
    this.getGoalTypes();
    this.getGoalGroups();
    this.getGoalIntervals();
    this.getPermissionsByUserId();
  }

  // Toast notification helpers
  private showSuccess(): void {
    this.toastr.success('New Goal has been successfully added.');
  }

  private showUpdated(): void {
    this.toastr.success('Goal has been successfully Updated.');
  }

  private showError(): void {
    this.toastr.error('Goal Already Exist');
  }

  isSelected(goal: goals): boolean {
    return this.selectedgoalIds.includes(goal.goalId.toString());
  }

  highlightedRow(id: any): void {
    this.selectedRowIndex = id ? Number(id) : null;
  }

  // Checkbox selection management
  handleCheckboxChange(event: any, goal: goals): void {
    const goalIdStr = goal.goalId.toString();
    
    if (event.target.checked) {
      this.selectedgoalIds.push(goalIdStr);
      goal.gIsSelected = true;
    } else {
      const index = this.selectedgoalIds.indexOf(goalIdStr);
      if (index !== -1) {
        this.selectedgoalIds.splice(index, 1);
      }
      goal.gIsSelected = false;
      this.headerCheckboxSelected = false;
    }
    
     this.updateHeaderCheckboxState();
  }

  private uncheckSelectedCheckboxes(): void {
    this.selectedgoalIds = [];
    this.headerCheckboxSelected = false;
    this.goals.forEach(goal => goal.gIsSelected = false);
  }

  private closeModal(): void {
    this.modalConfirmCloseButton?.nativeElement.click();
  }

toggleAllCheckboxes(): void {
  this.headerCheckboxSelected = !this.headerCheckboxSelected;
  
  if (this.headerCheckboxSelected) {
    this.GoalsArray.forEach(goal => {
      const goalIdStr = goal.goalId.toString();
      if (!this.selectedgoalIds.includes(goalIdStr)) {
        this.selectedgoalIds.push(goalIdStr);
      }
      goal.gIsSelected = true;
    });
  } else {
    this.GoalsArray.forEach(goal => {
      const goalIdStr = goal.goalId.toString();
      const index = this.selectedgoalIds.indexOf(goalIdStr);
      if (index !== -1) {
        this.selectedgoalIds.splice(index, 1);
      }
      goal.gIsSelected = false;
    });
  }
}
  private updateHeaderCheckboxState(): void {
  const allDisplayedSelected = this.GoalsArray.length > 0 && 
    this.GoalsArray.every(goal => this.selectedgoalIds.includes(goal.goalId.toString()));
  
  this.headerCheckboxSelected = allDisplayedSelected;
}

  // Data fetching
  getValue(): void {
    this.masterservice.getGoalValues().subscribe((res) => {
      this.goalValue = res as goals[];
    });
  }

  getGoalIntervals(): void {
    this.masterservice.getGoalIntervals().subscribe((res) => {
      this.goalIntervals = res as goals[];
    });
  }

  getGoalGroups(): void {
    this.masterservice.getGoalGroups(this.userData.companyID).subscribe((res) => {
      this.goalGroups = res as goals[];
      this.filteredGoalGroup = res as goals[];
    });
  }

  getgoals(): void {
    const userdata = this.masterservice.getUserDetailsFromStorage();
    const companyId = userdata.companyID;

    this.masterservice.getGoals(companyId).subscribe((res) => {
      this.goals = res as goals[];
      this.GoalsArray = res as goals[];

      // Filter based on active status
      this.GoalsArray = this.GoalsArray.filter(item => 
        this.isButtonActive ? item.active === true : item.active !== true
      );
      this.filtergoalIds = [];
      
      this.GoalsArray1 = this.GoalsArray;
      this.prepareExportList();
      this.getseparatedataforFilters();
      this.updateHeaderCheckboxState();
      this.isLoading = false;
    });
  }

  private prepareExportList(): void {
    this.exportList = this.goals
      .filter(goal => goal.active)
      .map(goal => ({
        Title: goal.goalName,
        Goal_Type: goal.goalDescr,
        Goal_Count: goal.goalCnt,
        Goal_Interval: goal.goalIntervals,
        Goal_Gropup: goal.groupName,
        Date_Created: this.formatDateForExport(goal.createdDt),
        Created_By: goal.userName
      }));
  }

  // Filter management
  getseparatedataforFilters(): void {
    this.ArrayForGoals = this.GoalsArray1;

    const filterArray = this.ArrayForGoals.reduce((accumulator: any, current) => {
      if (!accumulator.some((item: any) => item.goalTypeId === current.goalTypeId)) {
        current.isSelected = false;
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    
    this.GoalsArrayforFilter = filterArray;
    this.ArrayForGoals = filterArray;
  }

  clearFilter(dta: any): void {
    if (dta === 'goalType') {
      this.filtergoalIds = [];
      this.GoalsArrayforFilter.forEach(el => el.isSelected = false);
    }

    this.noData = false;
    this.getFilterData();
  }

  getFilterData(): void {
  const filteredArray = this.GoalsArray1.filter(item => 
    this.filtergoalIds.length === 0 || this.filtergoalIds.includes(item.goalTypeId)
  );

  this.noData = this.filtergoalIds.length > 0 && filteredArray.length === 0;
  this.GoalsArray = filteredArray;
  
  this.GoalsArray.forEach(goal => {
    goal.gIsSelected = this.selectedgoalIds.includes(goal.goalId.toString());
  });
  

  this.updateHeaderCheckboxState();
}

  selectedFilterCategory(dta: any): void {
    this.filterName = dta;
    if (dta === 'goatType') {
      this.GoalsArrayforFilter = this.GoalsArray;
    }
  }

  openFilterModal(modalState: string): void {
    if (modalState === 'Open') {
      this.isFilterModalOpen = true;
    }

    if (modalState === 'Close') {
      this.isFilterModalOpen = false;
      this.filtergoalIds = [];
      this.GoalsArrayforFilter.forEach((el) => (el.isSelected = false));
    }
  }

  collectFilterParameters(search: any): void {
    this.GoalsArrayforFilter.forEach((elements: goals) => {
      if (this.filterName === 'goalType' && elements.goalTypeId === search) {
        elements.isSelected = !elements.isSelected;
      }
    });

    if (this.filterName === 'goalType') {
      this.toggleFilterParameter(this.filtergoalIds, search);
    }
  }

  private toggleFilterParameter(filterArray: any[], search: any): void {
    const index = filterArray.indexOf(search);
    if (index !== -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(search);
    }
  }

  // Form management
  getGoalById(id: number): void {
    this.isEditable = true;
    this.highlightedRow(id);
    this.isUpdated = true;
    
    // Find the goal from existing array instead of making API call
    const selectedGoal = this.goals.find(goal => goal.goalId === id);
    this.filterGoalGroup(selectedGoal?.goalTypeId || 0);
    if (selectedGoal) {
      this.goal = { ...selectedGoal }; // Create a copy to avoid direct mutation
      this.goalName = this.goal?.goalName;
    }
  }
  isValidated(): boolean {
    return !!(this.goal.goalName && this.goal.goalName?.trim().length > 0 &&
      this.goal.goalTypeId > 0 && this.goal.goalIntervalId > 0 &&
      this.goal.goalValueId > 0 && this.goal.goalGroupId > 0 &&
      this.goal.goalCnt && this.goal.goalCnt > 0);
  }
  createGoal(data: goals): void {
    const userdata = this.masterservice.getUserDetailsFromStorage();
    data.companyId = userdata.companyID;
    data.createdByUserId = userdata.userId;
    
    this.masterservice.addUpdateGoal(data).subscribe(
      (res) => {
        if (res) {
          this.getgoals();
          this.isUpdated ? this.showUpdated() : this.showSuccess();
          this.isUpdated = false;
        }
      },
      (err) => {
        this.showError();
      }
    );
  }

  // Delete operations
  deleteGoals(deleteParameter: number | number[]): void {
    const idsArray = Array.isArray(deleteParameter) ? deleteParameter : [deleteParameter];
    const selectedIds = idsArray.join(',');
    
    this.masterservice.deleteGoal(selectedIds).subscribe((res) => {
      if (res) {
        this.toastr.success('Goals deleted successfully.');
        this.getgoals();
        this.uncheckSelectedCheckboxes();
        this.closeModal();
      }
    });
  }

  openConfirmPopup(goalId: any): void {
    const hasSelection = goalId !== null && !(Array.isArray(goalId) && goalId.length === 0);
    this.deleteButtonClickedWithSelection = hasSelection;
    this.deleteButtonClickedWithoutSelection = !hasSelection;
    this.deleteParameter = hasSelection ? goalId : null;
  }

  clearForm(): void {
    this.isEditable = false;
    this.isUpdated = false;
    this.goal = new goals();
    this.filteredGoalGroup = this.goalGroups;
  }

  getGoalTypes(): void {
    this.masterservice.getGoalTypes().subscribe((res) => {
      this.goalTypes = res as goals[];
    });
  }

  private formatDateForExport(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  exportToExcel(): void {
    this.exportExcelService.exportAsExcelFile(this.exportList, 'Goals-data');
  }

  activeTab(check: boolean): void {
    this.isLoading = true;
    this.GoalsArray=[];
    this.isButtonActive = check;
    this.uncheckSelectedCheckboxes();
    this.getgoals();
  }

  // Permissions
  private getPermissionsByUserId(): void {
    this.userservice.getUserRolesandPerm().then((res) => {
      const permissions = res as UserPermissionsModel[];
      const permissionNames = permissions?.map(pr => pr.name) || [];
      this.permissionService.loadPermissions(permissionNames);
    });
  }

  filterGoalGroup(goalTypeId: number): void {
    if (!goalTypeId || goalTypeId === 0) {
      this.filteredGoalGroup = this.goalGroups;
      return;
    }
    const filtered = this.goalGroups.filter(group => group.goalTypeId === goalTypeId);
    this.filteredGoalGroup = filtered.length > 0 ? filtered : this.goalGroups;
  }

}
